﻿import { defineComponent, ref } from 'vue';
declare global { interface Window { ttcPaymentgateway: any; } }

import { Payment } from "../../../services/payment";
import { payment_response } from "../../../objects/ttc/payment_response/response";
import { DataPayload, PayPalOrder } from "../../../objects/v1_3/payment/initialise/paypal_order"
import { resp } from "../../../objects/ttc/payment_response/resp";
import { response } from "../../../objects/v1_3/payment/initialise/response";
//import payment_paypal_button from "./payment_paypal_button.vue";
import { response_method } from "../../../objects/v1_3/payment/initialise/response_method";
import { booking_search_group } from "../../../objects/v1_2/Booking_Details/booking_search_group";

import { payment } from "../../../objects/ttc/payment_gateway/payment";
import { request_payment_initialise_internal } from "../../../objects/v1_3/payment/initialise/request_payment_initialise_internal";
import { response_login_payment } from "../../../objects/agent/identity/v1_3/response_login_payment";
import { payment_transaction } from 'modules/tms/booking_engine/objects/ttc/payment_gateway/payment_transaction';
import { Booking } from "../../../services/booking";
import { return_status } from 'modules/tms/booking_engine/objects/v1_3/return_status';

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
const Pay: Payment = new Payment();
const Book: Booking = new Booking();

export default defineComponent({
    name: "payment_credit_card",
    components: {
        //payment_paypal_button
    },
    props: {
        consumer_display: String,
        credit_card_div: String,
        paymentprovider_div_button: String,
        paymentprovider_div_frame: String,
        paymentprovider_iframe: HTMLElement
    },
    setup() {
        const paymentLogos: Record<string, string> = {
            stripe: '/logo-stripe.svg',
            paypal: '/logo-paypal.svg',
            cybersource: '/logo-cybersource.svg',
            ttc_payment_gateway: '/logo-ttc-black.svg'
        };
        // const paypalButtonRef = ref<InstanceType<typeof payment_paypal_button> | null>(null);
        // const initPaypal = () => { paypalButtonRef.value?.initialisePaypal(); };        
        return {
            paymentLogos,
            // paypalButtonRef,
            // initPaypal
        }
    },
    data() {
        return {
            payment_response: new resp() as resp,
            initialised_payment: false as boolean,
            ttc_payment_form: false as boolean,
            finalised_payment: true as boolean,
            storepaymentResponse: new payment_response() as payment_response,
            paymentprovider_url: "",
            paymentiframe_url: "",
            showAltUrl: false,
            is_payment_method_payment_gateway: false as boolean,
            is_payment_method_cybersource: false as boolean,
            is_payment_method_stripe: false as boolean,
            is_payment_method_paypal: false as boolean,
            is_payment_method_bank_transfer: false as boolean,
            is_payment_provider_available_ttc_payment_gateway: false as boolean,
            is_payment_provider_available_cybersource: false as boolean,
            is_payment_provider_available_stripe: false as boolean,
            is_payment_provider_available_paypal: false as boolean,
            is_iFrame: true as boolean,
            hide_payment_ttcgateway : true as boolean,
            hide_payment_paypal : true as boolean,
            hide_payment_paymentprovider_button : true as boolean,
            hide_payment_paymentprovider_iframe : true as boolean,
            show_fallback_button: false as boolean,
            show_redirect_msg: false as boolean,
            show_payment_methods: false as boolean,
            show_hints: false as boolean,
            available_payment_methods : [] as string[],
            selected_payment_provider: "" as string,
            paypal_payment_initialise : null as response | null,
            is_Test: false as boolean //set this to true to test a response without going through the payment provider. DO NOT COMMIT WITH THIS SET TO TRUE
        }
    },
    methods: {
        get_Booking(): booking_search_group {
            return this.$store.getters.get_Booking;
        },
        async check_out_page() {
            this.show_hints = (import.meta.env.VITE_PAYMENT_SHOW_HINTS === "true") ? true : false;
            this.show_redirect_msg = true;
            this.is_iFrame = JSON.parse(import.meta.env.VITE_PAYMENT_PAYMENTPROVIDER_USE_IFRAME);

            if (this.get_payment_provider() == null || this.get_payment_provider() == "") {
                this.show_payment_methods = import.meta.env.VITE_PAYMENT_METHOD.indexOf(',') > -1 ? true : false;

                this.available_payment_methods = import.meta.env.VITE_PAYMENT_METHOD.split(','); 
                this.is_payment_provider_available_cybersource = (this.available_payment_methods.indexOf('cybersource') > -1) ? true : false;
                this.is_payment_provider_available_stripe = (this.available_payment_methods.indexOf('stripe') > -1) ? true : false;
                this.is_payment_provider_available_paypal = (this.available_payment_methods.indexOf('paypal') > -1) ? true : false;
                this.is_payment_provider_available_ttc_payment_gateway = (this.available_payment_methods.indexOf('ttc_payment_gateway') > -1) ? true : false;
                
                return;
            }

            this.is_payment_method_payment_gateway = (this.get_payment_provider() == 'ttc_payment_gateway');
            this.is_payment_method_cybersource = (this.get_payment_provider() == 'cybersource');
            this.is_payment_method_stripe = (this.get_payment_provider() == 'stripe');
            this.is_payment_method_paypal = (this.get_payment_provider() == 'paypal');
            this.is_payment_method_bank_transfer = (this.get_payment_provider() == 'bank_transfer');

            //don't offer method choice when method hasbeen selected except for Paypal as it is rendered inline
            if (this.is_payment_method_paypal) {
                this.initPaypal();
                this.hide_payment_paypal = false;
                return;
            }

            this.show_payment_methods = false;

            if ((this.is_payment_method_cybersource || this.is_payment_method_stripe) && this.is_iFrame) {
                window.addEventListener("message", this.paymentprovider_confirmation_redirect, false);
            }

            if (this.$store.getters.get_Agent_Login?.payment_methods.length > 0) {
                let has_cc_payment_method : boolean = false;
                let has_bt_payment_method : boolean = false;
                this.$store.getters.get_Agent_Login.payment_methods.forEach(pm => {
                    if (pm.method == "CC") {
                        has_cc_payment_method = true;
                    }
                    else if (pm.method == "BT") {
                        has_bt_payment_method = true;
                    }
                });

                if (has_cc_payment_method) {
                    if (this.consumer_display == "false") {
                        await this.Initialise_Payment(false, this.$store.getters.get_Selected_Payment.nett_gross == "N");
                    }
                } else if (has_bt_payment_method) {
                    this.initialised_payment = true;
                    this.ttc_payment_form = false;
                    this.finalised_payment = true;
                } else {
                    this.initialised_payment = true;
                    this.ttc_payment_form = true;
                    this.finalised_payment = true;
                }
            } else {
                if (this.consumer_display == "true") {
                    await this.Initialise_Payment(true, this.$store.getters.get_Selected_Payment.nett_gross == "N");
                }
            }
        },
        async set_payment_provider_and_checkout(payment_provider: string) {
            this.selected_payment_provider = payment_provider;
            let payment_session_old : request_payment_initialise_internal = this.$store.getters.get_Payment_Session;
            this.set_payment_provider(payment_provider, payment_session_old?.payment_initialise?.nett_sale ?? this.$store.getters.get_Selected_Payment.nett_gross == "N");
            await this.check_out_page();
        },
        Get_Payment_App_Id(): string {
            let payment_app_id : any = import.meta.env.VITE_PAYMENT_APP_ID; //default
            if (this.$store.getters.get_Payment_APP_ID != null && this.$store.getters.get_Payment_APP_ID != '') {
                payment_app_id = this.$store.getters.get_Payment_APP_ID; //set by paylink
            }
            return payment_app_id;
        },
        has_Payment_Session() : boolean {
            let Payment_Session = this.$store.getters.get_Payment_Session;
            if (!(Payment_Session == undefined || Payment_Session == null || Payment_Session.payment_session == null)) {
                return true;
            }
            return false;
        },
        async Initialise_Payment(consumer_sale: boolean, nett_sale: boolean) {
            var is_Full_Payment : boolean = this.$store.getters.get_Payment_Full_Payment;
            var is_Deposit_Payment : boolean = this.$store.getters.get_Payment_Deposit;
            var get_Booking = this.$store.getters.get_Booking;
            var is_consumer_sale = consumer_sale;
            var is_nett_sale = nett_sale;
            
            let payment_session : request_payment_initialise_internal | null = null;
            if (this.has_Payment_Session()) {
                payment_session = this.$store.getters.get_Payment_Session;

                //var is_Full_Payment : boolean = payment_session.payment_initialise.full_payment ?? true;
                //var is_Deposit_Payment : boolean = payment_session.payment_initialise.deposit ?? false;
                get_Booking = payment_session?.get_booking;
                is_nett_sale = payment_session?.payment_initialise.nett_sale ?? false;
            }

            let provider_name : string | null = this.selected_payment_provider;
            let Payment_Initialise: response = await Pay.Payment_Initialise(is_Full_Payment, is_Deposit_Payment, get_Booking, payment_session, this.$store.getters.get_Agent_Login, is_consumer_sale, is_nett_sale, this.Get_Payment_App_Id(), provider_name).then(response => { return response.json(); })
            let Payment_Method: response_method = Pay.Payment_Method_ForProvider(Payment_Initialise, this.get_payment_provider());

            let payment_amount : number = this.getPaymentAmount(payment_session) ?? 0;
            let balance_outstanding : number | null = await this.get_balance_outstanding();
            //check if the balance outstanding is actually >= payment amount, if not route to confirmation to avoid overpayments
            if (balance_outstanding !== null && (balance_outstanding < payment_amount || payment_amount <= 0 || balance_outstanding <= 0)) {
                this.$router.push({ path: "/confirmation" });
                return;
            }

            await Pay.get_paymentprovider_url(Payment_Initialise, this.get_payment_provider());
            let Payment_Transation: payment = new payment();      
            if (Payment_Method.data_payload != null) {
                Payment_Transation = JSON.parse(Payment_Method.data_payload ?? "");      
            }

            Payment_Transation.transactionInfo.bookingType = "CD";

            if(!this.isAgent_Login() && !(this.isAAT() || this.isSEIT())) {
                Payment_Transation = this.setBlankDefaultAddress(Payment_Transation);
            }
            this.payment_response.ttc = Payment_Transation

            this.initialised_payment = true;
            this.ttc_payment_form = false;
            this.finalised_payment = true;

            if (this.is_payment_method_payment_gateway) {
                 this.hide_payment_ttcgateway = false;
                 if (this.is_Test) {
                    this.Payment_Processed(this.getTestPaymentResponse());
                 } else {
                    window.ttcPaymentgateway.attachPaymentOption(JSON.stringify(Payment_Transation), "#" + this.credit_card_div, (paymentResponse: payment_response) => {
                        this.Payment_Processed(paymentResponse);
                    });
                }
            } 
            else if (this.is_payment_method_cybersource || this.is_payment_method_stripe) {
                this.paymentprovider_url = await Pay.get_paymentprovider_url(Payment_Initialise, this.get_payment_provider());
                if (this.is_iFrame) {
                    this.paymentiframe_url = this.paymentprovider_url;
                    this.hide_payment_paymentprovider_iframe = false;
                } else {
                    window.location.href = this.paymentprovider_url;
                    setTimeout(() => { this.show_fallback_button = true; }, 3000);
                }
            }
            else if (this.is_payment_method_paypal) {
                this.hide_payment_paypal = false;
            }
            setTimeout(() => { this.show_redirect_msg = false; }, 3000);
        },
       async paypalCreateOrder() {
            try {
                var is_Full_Payment : boolean = this.$store.getters.get_Payment_Full_Payment;
                var is_Deposit_Payment : boolean = this.$store.getters.get_Payment_Deposit;
                var get_Booking = this.$store.getters.get_Booking;
                var is_consumer_sale = this.consumer_display == "true";
                var is_nett_sale = this.$store.getters.get_Selected_Payment.nett_gross == "N";
                
                let payment_session : request_payment_initialise_internal | null = null;
                if (this.has_Payment_Session()) {
                    payment_session = this.$store.getters.get_Payment_Session;

                    //var is_Full_Payment : boolean = payment_session.payment_initialise.full_payment ?? true;
                    //var is_Deposit_Payment : boolean = payment_session.payment_initialise.deposit ?? false;
                    get_Booking = payment_session?.get_booking;
                    is_nett_sale = payment_session?.payment_initialise.nett_sale ?? false;
                }

                let provider_name : string | null = this.selected_payment_provider;
                let Payment_Initialise: response = await Pay.Payment_Initialise(is_Full_Payment, is_Deposit_Payment, get_Booking, payment_session, this.$store.getters.get_Agent_Login, is_consumer_sale, is_nett_sale, this.Get_Payment_App_Id(), provider_name).then(response => { return response.json(); })
                let Payment_Method: response_method = Pay.Payment_Method_ForProvider(Payment_Initialise, this.get_payment_provider());
                this.paypal_payment_initialise = Payment_Initialise;

                let payment_amount : number = this.getPaymentAmount(payment_session) ?? 0;
                let balance_outstanding : number | null = await this.get_balance_outstanding();
                //check if the balance outstanding is actually >= payment amount, if not route to confirmation to avoid overpayments
                if (balance_outstanding !== null && (balance_outstanding < payment_amount || payment_amount <= 0 || balance_outstanding <= 0)) {
                    this.$router.push({ path: "/confirmation" });
                    return;
                }
        
                // let payload_json = JSON.parse(Payment_Initialise.payment_methods[0].data_payload ?? "");
                // const payload = new DataPayload(payload_json);
                let payload = JSON.parse(Payment_Initialise.payment_methods[0].data_payload ?? "");

                if (payload.paypal_order.Id) {
                    return payload.paypal_order.Id;
                }
                const errorDetail = payload.paypal_order?.Details?.[0];
                const errorMessage = errorDetail
                    ? `${errorDetail.issue} ${errorDetail.description} (${payload.paypal_order.Debug_id})`
                    : JSON.stringify(payload.paypal_order);

                throw new Error(errorMessage);
            } catch (error) {
                console.error(error);
                this.paypalResultMessage(`Could not initiate PayPal Checkout...<br><br>${error}`);
            }
        },
        async onPaypalApprove(data: any, actions: any) {
            try {
                let order_id = data.orderID;

                var is_Full_Payment : boolean = this.$store.getters.get_Payment_Full_Payment;
                var is_Deposit_Payment : boolean = this.$store.getters.get_Payment_Deposit;
                var get_Booking = this.$store.getters.get_Booking;
                var is_consumer_sale = this.consumer_display == "true";
                var is_nett_sale = this.$store.getters.get_Selected_Payment.nett_gross == "N";
               
                //let payment_session : request_payment_initialise_internal = this.paypal_payment_session ?? this.$store.getters.get_Payment_Session;
                //var is_Full_Payment : boolean = payment_session.payment_initialise.full_payment ?? true;
                //var is_Deposit_Payment : boolean = payment_session.payment_initialise.deposit ?? false;
                //get_Booking = payment_session?.get_booking;
                //is_nett_sale = payment_session?.payment_initialise.nett_sale ?? false;

                let provider_name : string = this.selected_payment_provider;

                let capture_repsonse : return_status = await Pay.Payment_Capture(is_Full_Payment, is_Deposit_Payment, get_Booking, this.paypal_payment_initialise, this.$store.getters.get_Agent_Login, is_consumer_sale, is_nett_sale, this.Get_Payment_App_Id(), provider_name, order_id).then(response => { return response.json(); })

                if (capture_repsonse.error_information != null && capture_repsonse.error_information != "") {
                    this.paypalResultMessage(capture_repsonse.error_information);
                    throw new Error(capture_repsonse.error_information);
                }

                //let payload_json = JSON.parse(await capture_repsonse.return_data ?? "");
                //const payload = new DataPayload(payload_json);
                const returnData = JSON.parse(await capture_repsonse?.return_data);

                const orderData = returnData.paypal_order;
                // Three cases to handle:
                //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                //   (2) Other non-recoverable errors -> Show a failure message
                //   (3) Successful transaction -> Show confirmation or thank you message

                const errorDetail = orderData?.Details?.[0];

                if (errorDetail?.Issue === "INSTRUMENT_DECLINED") {
                    // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                    // recoverable state, per
                    // https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
                    return actions.restart();
                } else if (errorDetail) {
                    // (2) Other non-recoverable errors -> Show a failure message
                    throw new Error(
                        `${errorDetail.Description} (${orderData.DebugId})`
                    );
                } else if (!orderData.PurchaseUnits) {
                    throw new Error(JSON.stringify(orderData));
                } else {
                    // (3) Successful transaction -> Show confirmation or thank you message
                    // Or go to another URL:  actions.redirect('thank_you.html');
                    const transaction =
                        orderData?.PurchaseUnits?.[0]?.Payments?.Captures?.[0] ||
                        orderData?.PurchaseUnits?.[0]?.Payments?.Authorizations?.[0];
                    this.paypalResultMessage(
                        `Transaction ${transaction.Status}: ${transaction.Id}<br>
                        <br>See console for all available details`
                    );
                    console.log(
                        "Capture result",
                        orderData,
                        JSON.stringify(orderData, null, 2)
                    );

                    this.$router.push({ path: "/confirmation" })
                }
            } catch (error) {
                console.error(error);
                this.paypalResultMessage(
                    `Sorry, your transaction could not be processed...<br><br>${error}`
                );
            }
        },
        paypalResultMessage(message) {
            let container = document.querySelector("#paypal-result-message");
            if (container != null) container.innerHTML = message;
        },
        initPaypal() {
            const self = this; // Store reference to the Vue component instance

            const script = document.createElement('script');
            script.src = import.meta.env.VITE_PAYMENT_PAYPAL_LIBRARY;
            
            let iso_currency_code = this.$store.getters.get_Currency.currency_info?.iso_currency_code ?? null;
            if (iso_currency_code != null) {
                script.src = script.src + '&currency=' + iso_currency_code;
            }

            script.addEventListener('load', () => {
                window.paypal.Buttons({
                    style: {
                        shape: "pill",
                        layout: "vertical",
                        color: "gold",
                        label: "paypal",
                    },
                    createOrder: async () => {
                        return await self.paypalCreateOrder();
                    },
                    // Use 'self' instead of 'this' to reference the component instance
                    onApprove: async (data: any, actions: any) => {
                        await self.onPaypalApprove(data, actions);
                    },
                    onError: (err: any) => {
                        console.error('PayPal Error:', err);
                    }
                }).render('#paypal-button-container');
            });

            document.body.appendChild(script);
        },
        isAAT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "AAT") {
                return true;
            }
            return false;
        },
        isSEIT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "SEIT") {
                return true;
            }
            return false;
        },
        getPaymentAmount(payment_session : request_payment_initialise_internal | null) : number {
            let amount : number = 0;
            let fee : number = 0;
            payment_session?.payment_initialise?.payments?.forEach(p => {
                fee = fee + (p.fee ?? 0);
            });

            amount = payment_session?.payment_initialise?.amount ?? 0;

            return amount - fee;
        },
        async get_balance_outstanding(): Promise<number | null> {
            let group_booking_id = this.$store.getters.get_Booking?.group_booking_id;

            let booking_details_old = await Book.Get_Book(group_booking_id.toString(), this.$store.getters.get_Agent_Login);
            let session_id = booking_details_old.session_id ?? "";

            let booking_details = await Book.Get_Booking_Session(this.$store, group_booking_id.toString(), session_id).then((response) => {
                return response;
            });

            let provider = this.get_payment_provider();
            let payment_session_id = this.$store.getters.get_Payment_Session?.payment_session?.toString() ?? "";    

            //retrieve the payment session from the store and update it with the latest payment booking details
            let payment_session_old : request_payment_initialise_internal = this.$store.getters.get_Payment_Session;
            if (payment_session_old != null ) {
                let provider = payment_session_old?.provider_name;
                let payment_session_id = payment_session_old?.payment_session?.toString() ?? "";
            }

            let app_id = this.get_Payment_App_Id();
            if (payment_session_id == null || payment_session_id == "" || provider == null || provider == "") {
                return null;
            }

            let payment_session : request_payment_initialise_internal = await Pay.Get_Payment_Session(this.$store, payment_session_id, provider ?? "", app_id);
            
            if (payment_session == null) {
                return null;
            }

            payment_session.provider_name = provider;

            if (booking_details.trips != null && booking_details.trips.length > 0) {
                payment_session.get_booking.trips = booking_details.trips;
            } else {
                booking_details = payment_session?.get_booking;
            }
            this.$store.commit('Payment_Session', { Payment_Session: payment_session });

            this.set_payment_provider(provider, payment_session.payment_initialise.nett_sale);

            this.$store.commit("Setup_Booking", { Booking_Details: booking_details });

            return Book.get_total_outstanding(booking_details);
        },
        get_Payment_App_Id(): string {
            let payment_app_id : any = import.meta.env.VITE_PAYMENT_APP_ID; //default
            if (this.$store.getters.get_Payment_APP_ID != null && this.$store.getters.get_Payment_APP_ID != '') {
                payment_app_id = this.$store.getters.get_Payment_APP_ID; //set by paylink
            }
            return payment_app_id;
        },
        get_payment_provider(): string {
            let method : string = "";

            //only use default payment method if there is only one available payment method
            if (import.meta.env.VITE_PAYMENT_METHOD.indexOf(',') == -1) {
                method = import.meta.env.VITE_PAYMENT_METHOD;
            }

            if (this.$store.getters.get_Selected_Payment != null && this.$store.getters.get_Selected_Payment.provider != null) {
                method = this.$store.getters.get_Selected_Payment.provider;
            }

            return method;
        },
        set_payment_provider(provider: string, is_nett_sale: boolean = false) {
            //set it in the store so that it can be used by other components
            let selected_payment_method : response_login_payment = this.$store.getters.get_Selected_Payment;
            selected_payment_method.method = 'CC';
            selected_payment_method.nett_gross = (is_nett_sale == true) ? "N" : "G";
            selected_payment_method.description = 'CreditCard';
            selected_payment_method.provider = provider;
            this.$store.commit("Set_Payment_Selected", { Selected_Payment: selected_payment_method});
        },
        redirect_to_paymentprovider() {
            window.location.href = this.paymentprovider_url; // full page
        },
        paymentprovider_confirmation_redirect(event) {
            if(event.origin !== import.meta.env.VITE_DEFAULT_URL && event.origin !== 'http://localhost:3001') return;

            if (this.is_payment_method_cybersource || this.is_payment_method_stripe) this.$router.push({ path: "/confirmation" });
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        onLoadIframe(event) {
        },
        async Payment_Processed(Payment_Response: payment_response) {

            console.log("Payment Response", Payment_Response);

            this.payment_response.response_payment = Payment_Response;

            if(Payment_Response?.paymentSuccessful == false) {
                this.$router.push({name: 'failed_payment', params: { reason: "reason="+Payment_Response?.paymentStatus} });
            }
            else if (Payment_Response?.paymentSuccessful != null) {
                this.finalised_payment = false;
                this.ttc_payment_form = true;
                this.showAltUrl = false;
                
                let Return_Status = await Pay.Commit_Payment(this.payment_response, this.Get_Payment_App_Id());

                this.$router.push({ path: "/confirmation" });
            }

            this.finalised_payment = true;
        },
        setBlankDefaultAddress(payment: payment): payment {
            payment.transactionInfo.addressCity = "";
            payment.transactionInfo.addressCountry = "";
            payment.transactionInfo.addressLine1 = "";
            payment.transactionInfo.addressLine2 = "";
            payment.transactionInfo.addressPostalCode = "";

            return payment;

        },
        openPaymentProvider() {
            window.open(this.paymentprovider_url, "_blank"); //_self
        },
        GetBrand(): string {
            return String(import.meta.env.VITE_DEFAULT_CLASS);
        },
        getTestPaymentResponse(): payment_response {
            var paymentResponse = new payment_response();
            paymentResponse.paymentSuccessful = true;
            paymentResponse.event = "paymentAttemptResult";
            paymentResponse.transactionRef = "AAAUDS-TTC-3094317-4";
            paymentResponse.paymentSuccessful = true;
            paymentResponse.paymentStatus = "Authorised";
            paymentResponse.customSuccessPage = false;
            paymentResponse.paymentDetails.transactionId = "7811693948206052204506";
            paymentResponse.paymentDetails.billToFirstName = "Barry";
            paymentResponse.paymentDetails.billToLastName = "Test";
            paymentResponse.paymentDetails.billToAddressLine1 = "6 Canning Street";
            paymentResponse.paymentDetails.billToAddressLine2 = "Atholl Exchange, RadicalTravel";
            paymentResponse.paymentDetails.billToAddressCity = "Edinburgh";
            paymentResponse.paymentDetails.billToAddressState = "SCT";
            paymentResponse.paymentDetails.billToAddressCountry = "GB";
            paymentResponse.paymentDetails.billToAddressPostalCode = "Eh3 8eg";
            paymentResponse.paymentDetails.lastFourDigits = "1111";
            paymentResponse.paymentDetails.amount.currency = "AUD";
            paymentResponse.paymentDetails.amount.fee = "0";
            paymentResponse.paymentDetails.amount.total = "11.11";
            paymentResponse.paymentDetails.paymentMethod = "creditcard";
            return paymentResponse;
        }
    },
    mounted() {
        this.check_out_page();
    }
})